import styled from 'styled-components';

import { StyleColor, NewStyleColor } from '../../../../../utils/styles-constants';
import { hexToRgba } from '../../../../../utils/style';

interface InputWrapperProps {
	isOpacity?: boolean;
}

const Overlay = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 1;
	padding: 15px;
	border-radius: 13px;
	background-color: ${NewStyleColor.Grey900};
`;

const ControlsWrapper = styled('div')`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;

	.react-colorful {
		width: 175px;
		height: 175px;
	}
`;

const InputWrapper = styled('div')`
	box-sizing: border-box;
	position: relative;
	width: ${({ isOpacity }: InputWrapperProps) => isOpacity ? '70px' : '100px'};
	height: 34px;
	margin: ${({ isOpacity }: InputWrapperProps) => isOpacity ? '0 auto' : '0 0 20px'};
	border-radius: 6px;
	background-color: ${hexToRgba(StyleColor.White, 10)};
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 34px;
	color: ${StyleColor.White};

	input {
		box-sizing: border-box;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		width: inherit;
		height: inherit;
		padding: 10px;
		border: 1px solid transparent;
		outline: 0;
		border-radius: inherit;
		background-color: inherit;
		font-family: inherit;
		font-size: inherit;
		line-height: 19px;
		text-transform: uppercase;
		color: inherit;
		-webkit-appearance: none;

		${({ isOpacity }: InputWrapperProps) => isOpacity
			? 'padding-right: 25px;'
			: 'padding-left: 20px;'
		}

		&:focus {
			border-color: ${StyleColor.White}
		}

		::-ms-clear {
			display: none;
		}
	}
`;

const ButtonsWrapper = styled('div')`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 17px;
`;

const Button = styled('button')`
	box-sizing: border-box;
	padding: 0;
	border: 0;
	outline: 0;
	background-color: transparent;
	font-family: HelveticaNeue, sans-serif;
	font-weight: 500;
	font-size: 16px;
	line-height: 20px;
	color: ${NewStyleColor.Blue450};
	letter-spacing: 0.5px;
	cursor: pointer;
`;

const Sign = styled('span')`
	position: absolute;
	top: 0;
	z-index: 1;

	&:first-child {
		left: 7px;
	}

	&:last-child {
		right: 7px;
	}
`;

export {
	Overlay,
	ControlsWrapper,
	InputWrapper,
	ButtonsWrapper,
	Button,
	Sign,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/ThemesPanel/ColorPicker/styles.ts